import { EMPTY_STRING } from '../../../constants/common'
import { DEFAULT_TIME_ZONE } from '../../../constants/date'
import { createNowDateInUkTimezone } from '../../../utils/date'

export const POST_ITEM = {
  body: null,
  building_groups: [],
  buildings: [],
  chat: null,
  comments_forbidden: false,
  counters: { likes: 5 },
  created: '2022-08-02T13:00:00.172000+02:00',
  created_by: 12831,
  date_from: '2022-08-02T13:00:00.172000+02:00',
  date_to: '2022-08-02T14:00:00.007000+02:00',
  files: [],
  is_liked: true,
  is_pinned: true,
  is_unread: false,
  last_messages: null,
  new_audience: ['ToAllFriends'],
  owner: {
    avatar_color: '#216ba5',
    fullname: 'Admin Admin Admin Admin Admin Admin Admin Admin Admin Admin ',
    group: 'admin',
    id: 12831,
    is_landlord: false,
    name: 'Admin',
    second_name: 'Admin',
    status: 2,
  },
  permissions: {
    can_add_comment: false,
    can_block_post: false,
    can_block_user: false,
    can_edit: false,
    can_like_post: true,
    can_pin_post: false,
    can_unblock_post: false,
    can_unblock_user: false,
    can_unlike_post: false,
    can_unpin_post: false,
    can_view_viewers: false,
  },
  post_type: {
    id: 5,
    title: 'post',
  },
  post_type_category: 'post',
  request_dump: null,
  requests: null,
  spam: false,
  status: 'online',
  style: null,
  text: '<p>news</p>',
  title: 'we',
  type: 1,
  updated: '2022-08-02T11:15:13.641853+02:00',
  uuid: '9db4c60c-1243-11ed-9138-0242ac140005',
}

export const POST_ITEM_TODAY = {
  automation_id: '123',
  body: null,
  building_groups: [],
  buildings: [],
  chat: null,
  comments_forbidden: false,
  counters: { likes: 1 },
  created: createNowDateInUkTimezone(DEFAULT_TIME_ZONE),
  created_by: 12831,
  date_from: null,
  date_to: null,
  files: [
    {
      created: '2024-09-23T17:27:04.796989+02:00',
      filename: 'file_example_XLS_10 (2).xls',
      height: null,
      id: 260672,
      mime_type: 'application/vnd.ms-excel',
      origin:
        'https://files.idwell.at/olga.redesign.idwell.at/private/2024/09/file_example_XLS_10_2.xls?Expires=1727259175&Signature=GWqXGzYG2A41HcSmQe858IWSEg6YJrzmOtA408PwuuUXHiGdlSHg4-ZDQDkqeKXIMxaZdXAJJdpy-TuCnOe1LX232TuyUQSQxscur4H5Y0r9MmbhnJP0ER8CWZ7Smqa1Q-yM7WvGzghiMt3KTQxAWG-jXCYzeFp7ybDyEKFw8Gfa8KFg~We~gCASEajZ5gCc4Pp7tC7I6OS3~RTdMW04XpmiHuHtnD~Ab59H27GsZdeiti9dZCmwVksptYvE0msr2X1n4M13H5wYpp-qOb10Y9GOQuW2fqoX1~Sk1E1qF99Ko0W4Kq6Hul34yjcU-U5VTj0T2fKSKWJ~~FId0ct8rA__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ',
      permissions: {
        can_delete: true,
      },
      preview: null,
      size: 8704,
      thumbnail:
        'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/130X110/olga.redesign.idwell.at/private/2024/09/file_example_XLS_10_2.xls?signed_redirect=1&Expires=1727259415&Signature=KyP0tpQp0oi7YHqhwdxW8vr63K4TkbdikrHzerUYvZY~40Pqnwlwz-Tck6qu3bBQDx~1vVwOly7ePmqebvSxPUZ9OR~6WUxIn6jgtiT0~CTg7VGfgi7GoNCdut6uVO3F9TF0q2zZMR4ClVmqmYnJ~ze3REvz2~KjQ6hyU6NqnRKr3nvmE3whfeUwbypyA2fugbsGvXAuzcDuqT-gsMbXqKDdUHnW8-siPuq3re2sgYe~4LXEshFDnQycrLXHWeZP1L4xp77FRbU8l5pN55D8HRk5mMVMI8rFjPO-DQVVN9UXsS80Y4g6QvaefoWwfw~5J2jjoeL1NDruRDx~x~7b6g__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy8xMzBYMTEwLyoiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MjcyNTk0MTV9fX1dfQ__',
      thumbnails: {
        512: 'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/512X512/olga.redesign.idwell.at/private/2024/09/file_example_XLS_10_2.xls?signed_redirect=1&Expires=1727259415&Signature=d2fY7jbfViGYLvVX5IzNZych2HpKlXwnOd-nqLbXNwd8ilwVh4dneoIGywYlNWRNOU77ERcvANJ48RIWibgDzAvHot6IYYHhkGvKyxcBlGfcctC7tK0GMHiunsvfkMaVjtjPhDtoJuRPTDz-eUQ1Yo-jgIEzri2prySpLOoRXWtuiThkKS7KL-ek7ua-xQvELTakbQen7VTZ19XZxYXAodTBg3lk289vpKfYTiIib81zUKBTVvOezc6W0~m-lM9YlBXJeivujCzVlicGIn1OMIeaaL0jfnDrTPVJ6mpLDtRnN~gNgSGoEPjX37C7TvcMR--5-VPBj~scEMYZ83181Q__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy81MTJYNTEyLyoiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MjcyNTk0MTV9fX1dfQ__',
        1020: 'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/1020X555/olga.redesign.idwell.at/private/2024/09/file_example_XLS_10_2.xls?signed_redirect=1&Expires=1727259415&Signature=GamL0R1yXnIt~U~lx-50dZAVPwv~ggEbgMUus0pwmXWemXsTe7y3geVd3EL2iCvEnkNKWiEEJyWEdcOYLXo6NNesBxSrjjAg5lhX5hULEVsWZ4SGHksYGyaF~q3Aoi3TODH2zriOrtW4X7pSrvYV~sZjMKM78Dgc-wtUdmDGQsAb7XwqRPpP0-1JlumvRUJ2xDNm77KxJ55xwdVjl5qgnIK0FyVYW2UDd4Iri9TYYzFYPawPZ301L7ra1prgVcWJPy4mTjyipSsacb6NdZgMF~9Bbt86QgliMWlmWU5Yd7S9N5lCVTymKmswW9Xm7FhI8ThYPnxppn3tfpshyWfzeg__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy8xMDIwWDU1NS8qIiwiQ29uZGl0aW9uIjp7IkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzI3MjU5NDE1fX19XX0_',
      },
      width: null,
    },
  ],
  is_liked: false,
  is_pinned: false,
  is_unread: false,
  last_messages: null,
  new_audience: ['ToAllColleagues', 'ToAllBuildings'],
  owner: {
    avatar: null,
    avatar_color: '#8421a5',
    flats_count: 0,
    fullname: 'Admin Admin',
    group: 'admin',
    id: 12831,
    is_landlord: false,
    name: 'Admin',
    second_name: 'Admin',
    status: 1,
  },
  permissions: {
    can_add_comment: true,
    can_block_post: true,
    can_block_user: true,
    can_edit: true,
    can_like_post: true,
    can_pin_post: true,
    can_unblock_post: false,
    can_unblock_user: false,
    can_unlike_post: false,
    can_unpin_post: false,
    can_view_viewers: true,
  },
  post_type: {
    id: 5,
    title: 'post',
  },
  post_type_category: 'post',
  request_dump: null,
  requests: null,
  spam: false,
  status: 'offline',
  style: null,
  text: '<p>hello world!</p>',
  title: 'hi',
  type: 1,
  updated: '2024-09-04T16:27:19.376287+02:00',
  uuid: 'cab74298-6ac9-11ef-bae7-0242ac120008',
}

export const POST_ITEM_RATING = {
  building_groups: [],
  buildings: [],
  counters: { likes: 5 },
  files: [],
  owner: {
    avatar: null,
    avatar_color: '#8421a5',
    flats_count: 0,
    fullname: 'Admin Admin',
    group: 'admin',
    id: 12831,
    is_landlord: false,
    name: 'Admin',
    second_name: 'Admin',
    status: 1,
  },
  permissions: {
    can_add_comment: true,
    can_block_post: true,
    can_block_user: true,
    can_edit: true,
    can_like_post: true,
    can_pin_post: true,
    can_unblock_post: false,
    can_unblock_user: false,
    can_unlike_post: false,
    can_unpin_post: false,
    can_view_viewers: true,
  },
  post_type: {
    id: 5,
    title: 'feedback_post',
  },
  post_type_category: 'system_post',
  requests: [
    {
      building: {
        id: '12',
        title: 'home',
      },
      id: 1,
      rating: {
        feedback: { feedback_uuid: '123', text: 'good' },
        id: 3015,
        value: 4,
      },
      request_no: 121,
      status: 3,
      title: 'request title',
    },
  ],
  text: EMPTY_STRING,
  title: 'rating',
  type: 1,
  uuid: 'cab74298-6ac9-11ef-bae7-0242ac120008',
}

export const POST_ITEM_GALLERY = {
  body: null,
  building_groups: [],
  buildings: [],
  chat: null,
  comments_forbidden: false,
  counters: { likes: 0 },
  created: createNowDateInUkTimezone(DEFAULT_TIME_ZONE),
  created_by: 12831,
  date_from: null,
  date_to: null,
  files: [
    {
      created: '2024-09-23T17:27:50.872910+02:00',
      filename: 'doc_page_1.jpeg',
      height: 1654,
      id: 1,
      mime_type: 'image/jpeg',
      permissions: {
        can_delete: true,
      },
      preview: null,
      size: 687668,
      thumbnail:
        'https://plus.unsplash.com/premium_photo-1693221705305-6eff5fa8e483?q=80&w=3271&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      thumbnails: {
        1020: 'https://plus.unsplash.com/premium_photo-1693221705305-6eff5fa8e483?q=80&w=3271&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      },
      width: 2339,
    },
    {
      created: '2024-09-23T17:27:04.796989+02:00',
      filename: 'file_example_XLS_10 (2).xls',
      height: null,
      id: 2,
      mime_type: 'application/vnd.ms-excel',
      origin:
        'https://files.idwell.at/olga.redesign.idwell.at/private/2024/09/file_example_XLS_10_2.xls?Expires=1727259175&Signature=GWqXGzYG2A41HcSmQe858IWSEg6YJrzmOtA408PwuuUXHiGdlSHg4-ZDQDkqeKXIMxaZdXAJJdpy-TuCnOe1LX232TuyUQSQxscur4H5Y0r9MmbhnJP0ER8CWZ7Smqa1Q-yM7WvGzghiMt3KTQxAWG-jXCYzeFp7ybDyEKFw8Gfa8KFg~We~gCASEajZ5gCc4Pp7tC7I6OS3~RTdMW04XpmiHuHtnD~Ab59H27GsZdeiti9dZCmwVksptYvE0msr2X1n4M13H5wYpp-qOb10Y9GOQuW2fqoX1~Sk1E1qF99Ko0W4Kq6Hul34yjcU-U5VTj0T2fKSKWJ~~FId0ct8rA__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ',
      permissions: {
        can_delete: true,
      },
      preview: null,
      size: 8704,
      thumbnail:
        'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/130X110/olga.redesign.idwell.at/private/2024/09/file_example_XLS_10_2.xls?signed_redirect=1&Expires=1727259415&Signature=KyP0tpQp0oi7YHqhwdxW8vr63K4TkbdikrHzerUYvZY~40Pqnwlwz-Tck6qu3bBQDx~1vVwOly7ePmqebvSxPUZ9OR~6WUxIn6jgtiT0~CTg7VGfgi7GoNCdut6uVO3F9TF0q2zZMR4ClVmqmYnJ~ze3REvz2~KjQ6hyU6NqnRKr3nvmE3whfeUwbypyA2fugbsGvXAuzcDuqT-gsMbXqKDdUHnW8-siPuq3re2sgYe~4LXEshFDnQycrLXHWeZP1L4xp77FRbU8l5pN55D8HRk5mMVMI8rFjPO-DQVVN9UXsS80Y4g6QvaefoWwfw~5J2jjoeL1NDruRDx~x~7b6g__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy8xMzBYMTEwLyoiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MjcyNTk0MTV9fX1dfQ__',
      thumbnails: {
        512: 'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/512X512/olga.redesign.idwell.at/private/2024/09/file_example_XLS_10_2.xls?signed_redirect=1&Expires=1727259415&Signature=d2fY7jbfViGYLvVX5IzNZych2HpKlXwnOd-nqLbXNwd8ilwVh4dneoIGywYlNWRNOU77ERcvANJ48RIWibgDzAvHot6IYYHhkGvKyxcBlGfcctC7tK0GMHiunsvfkMaVjtjPhDtoJuRPTDz-eUQ1Yo-jgIEzri2prySpLOoRXWtuiThkKS7KL-ek7ua-xQvELTakbQen7VTZ19XZxYXAodTBg3lk289vpKfYTiIib81zUKBTVvOezc6W0~m-lM9YlBXJeivujCzVlicGIn1OMIeaaL0jfnDrTPVJ6mpLDtRnN~gNgSGoEPjX37C7TvcMR--5-VPBj~scEMYZ83181Q__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy81MTJYNTEyLyoiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MjcyNTk0MTV9fX1dfQ__',
        1020: 'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/1020X555/olga.redesign.idwell.at/private/2024/09/file_example_XLS_10_2.xls?signed_redirect=1&Expires=1727259415&Signature=GamL0R1yXnIt~U~lx-50dZAVPwv~ggEbgMUus0pwmXWemXsTe7y3geVd3EL2iCvEnkNKWiEEJyWEdcOYLXo6NNesBxSrjjAg5lhX5hULEVsWZ4SGHksYGyaF~q3Aoi3TODH2zriOrtW4X7pSrvYV~sZjMKM78Dgc-wtUdmDGQsAb7XwqRPpP0-1JlumvRUJ2xDNm77KxJ55xwdVjl5qgnIK0FyVYW2UDd4Iri9TYYzFYPawPZ301L7ra1prgVcWJPy4mTjyipSsacb6NdZgMF~9Bbt86QgliMWlmWU5Yd7S9N5lCVTymKmswW9Xm7FhI8ThYPnxppn3tfpshyWfzeg__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy8xMDIwWDU1NS8qIiwiQ29uZGl0aW9uIjp7IkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzI3MjU5NDE1fX19XX0_',
      },
      width: null,
    },
    {
      created: '2024-09-23T17:27:04.796989+02:00',
      filename: 'file_example_XLS_10 (2).xls',
      height: null,
      id: 3,
      mime_type: 'application/vnd.ms-excel',
      origin:
        'https://files.idwell.at/olga.redesign.idwell.at/private/2024/09/file_example_XLS_10_2.xls?Expires=1727259175&Signature=GWqXGzYG2A41HcSmQe858IWSEg6YJrzmOtA408PwuuUXHiGdlSHg4-ZDQDkqeKXIMxaZdXAJJdpy-TuCnOe1LX232TuyUQSQxscur4H5Y0r9MmbhnJP0ER8CWZ7Smqa1Q-yM7WvGzghiMt3KTQxAWG-jXCYzeFp7ybDyEKFw8Gfa8KFg~We~gCASEajZ5gCc4Pp7tC7I6OS3~RTdMW04XpmiHuHtnD~Ab59H27GsZdeiti9dZCmwVksptYvE0msr2X1n4M13H5wYpp-qOb10Y9GOQuW2fqoX1~Sk1E1qF99Ko0W4Kq6Hul34yjcU-U5VTj0T2fKSKWJ~~FId0ct8rA__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ',
      permissions: {
        can_delete: true,
      },
      preview: null,
      size: 8704,
      thumbnail:
        'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/130X110/olga.redesign.idwell.at/private/2024/09/file_example_XLS_10_2.xls?signed_redirect=1&Expires=1727259415&Signature=KyP0tpQp0oi7YHqhwdxW8vr63K4TkbdikrHzerUYvZY~40Pqnwlwz-Tck6qu3bBQDx~1vVwOly7ePmqebvSxPUZ9OR~6WUxIn6jgtiT0~CTg7VGfgi7GoNCdut6uVO3F9TF0q2zZMR4ClVmqmYnJ~ze3REvz2~KjQ6hyU6NqnRKr3nvmE3whfeUwbypyA2fugbsGvXAuzcDuqT-gsMbXqKDdUHnW8-siPuq3re2sgYe~4LXEshFDnQycrLXHWeZP1L4xp77FRbU8l5pN55D8HRk5mMVMI8rFjPO-DQVVN9UXsS80Y4g6QvaefoWwfw~5J2jjoeL1NDruRDx~x~7b6g__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy8xMzBYMTEwLyoiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MjcyNTk0MTV9fX1dfQ__',
      thumbnails: {
        512: 'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/512X512/olga.redesign.idwell.at/private/2024/09/file_example_XLS_10_2.xls?signed_redirect=1&Expires=1727259415&Signature=d2fY7jbfViGYLvVX5IzNZych2HpKlXwnOd-nqLbXNwd8ilwVh4dneoIGywYlNWRNOU77ERcvANJ48RIWibgDzAvHot6IYYHhkGvKyxcBlGfcctC7tK0GMHiunsvfkMaVjtjPhDtoJuRPTDz-eUQ1Yo-jgIEzri2prySpLOoRXWtuiThkKS7KL-ek7ua-xQvELTakbQen7VTZ19XZxYXAodTBg3lk289vpKfYTiIib81zUKBTVvOezc6W0~m-lM9YlBXJeivujCzVlicGIn1OMIeaaL0jfnDrTPVJ6mpLDtRnN~gNgSGoEPjX37C7TvcMR--5-VPBj~scEMYZ83181Q__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy81MTJYNTEyLyoiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MjcyNTk0MTV9fX1dfQ__',
        1020: 'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/1020X555/olga.redesign.idwell.at/private/2024/09/file_example_XLS_10_2.xls?signed_redirect=1&Expires=1727259415&Signature=GamL0R1yXnIt~U~lx-50dZAVPwv~ggEbgMUus0pwmXWemXsTe7y3geVd3EL2iCvEnkNKWiEEJyWEdcOYLXo6NNesBxSrjjAg5lhX5hULEVsWZ4SGHksYGyaF~q3Aoi3TODH2zriOrtW4X7pSrvYV~sZjMKM78Dgc-wtUdmDGQsAb7XwqRPpP0-1JlumvRUJ2xDNm77KxJ55xwdVjl5qgnIK0FyVYW2UDd4Iri9TYYzFYPawPZ301L7ra1prgVcWJPy4mTjyipSsacb6NdZgMF~9Bbt86QgliMWlmWU5Yd7S9N5lCVTymKmswW9Xm7FhI8ThYPnxppn3tfpshyWfzeg__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy8xMDIwWDU1NS8qIiwiQ29uZGl0aW9uIjp7IkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzI3MjU5NDE1fX19XX0_',
      },
      width: null,
    },
    {
      created: '2024-09-23T17:27:04.800115+02:00',
      filename: 'simple (5).xml',
      height: null,
      id: 4,
      mime_type: 'text/xml',
      origin:
        'https://files.idwell.at/olga.redesign.idwell.at/private/2024/09/simple_5.xml?Expires=1727259175&Signature=HrSBR43FKO1XkMYVqM1YbiPrQVLXYcjqOMmpocy4P~iYMH8IcTwgerXlWqAx9sxbo51sEe6Ip3bOT6CMW5OrAeb7gqA4Mb5xGMnbGIic9Hb0PuxgxZ~jc5dnGgQTG81L-Iq028sJYM4SpOS39VNUAK~cu0OtQprBNx7ePC3FVgHowdu~hPayv5foUjuyEKaaOdQAm6HJ6w~ukie3K-MPV7QLzFfTIzOjW2C423ThLXRiSigcRMrDHjFs3N8asyT8QCgQVpRT0n5EM8rKL81RqD1hcuzoN3wfaGX7Gli076cKKMBpusPDRFW8TClyB2ngOfjGv~XGif1ze4sJUqCaIw__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ',
      permissions: {
        can_delete: true,
      },
      preview: null,
      size: 1119,
      thumbnail:
        'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/130X110/olga.redesign.idwell.at/private/2024/09/simple_5.xml?signed_redirect=1&Expires=1727259415&Signature=KyP0tpQp0oi7YHqhwdxW8vr63K4TkbdikrHzerUYvZY~40Pqnwlwz-Tck6qu3bBQDx~1vVwOly7ePmqebvSxPUZ9OR~6WUxIn6jgtiT0~CTg7VGfgi7GoNCdut6uVO3F9TF0q2zZMR4ClVmqmYnJ~ze3REvz2~KjQ6hyU6NqnRKr3nvmE3whfeUwbypyA2fugbsGvXAuzcDuqT-gsMbXqKDdUHnW8-siPuq3re2sgYe~4LXEshFDnQycrLXHWeZP1L4xp77FRbU8l5pN55D8HRk5mMVMI8rFjPO-DQVVN9UXsS80Y4g6QvaefoWwfw~5J2jjoeL1NDruRDx~x~7b6g__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy8xMzBYMTEwLyoiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MjcyNTk0MTV9fX1dfQ__',
      thumbnails: {
        512: 'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/512X512/olga.redesign.idwell.at/private/2024/09/simple_5.xml?signed_redirect=1&Expires=1727259415&Signature=d2fY7jbfViGYLvVX5IzNZych2HpKlXwnOd-nqLbXNwd8ilwVh4dneoIGywYlNWRNOU77ERcvANJ48RIWibgDzAvHot6IYYHhkGvKyxcBlGfcctC7tK0GMHiunsvfkMaVjtjPhDtoJuRPTDz-eUQ1Yo-jgIEzri2prySpLOoRXWtuiThkKS7KL-ek7ua-xQvELTakbQen7VTZ19XZxYXAodTBg3lk289vpKfYTiIib81zUKBTVvOezc6W0~m-lM9YlBXJeivujCzVlicGIn1OMIeaaL0jfnDrTPVJ6mpLDtRnN~gNgSGoEPjX37C7TvcMR--5-VPBj~scEMYZ83181Q__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy81MTJYNTEyLyoiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MjcyNTk0MTV9fX1dfQ__',
        1020: 'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/1020X555/olga.redesign.idwell.at/private/2024/09/simple_5.xml?signed_redirect=1&Expires=1727259415&Signature=GamL0R1yXnIt~U~lx-50dZAVPwv~ggEbgMUus0pwmXWemXsTe7y3geVd3EL2iCvEnkNKWiEEJyWEdcOYLXo6NNesBxSrjjAg5lhX5hULEVsWZ4SGHksYGyaF~q3Aoi3TODH2zriOrtW4X7pSrvYV~sZjMKM78Dgc-wtUdmDGQsAb7XwqRPpP0-1JlumvRUJ2xDNm77KxJ55xwdVjl5qgnIK0FyVYW2UDd4Iri9TYYzFYPawPZ301L7ra1prgVcWJPy4mTjyipSsacb6NdZgMF~9Bbt86QgliMWlmWU5Yd7S9N5lCVTymKmswW9Xm7FhI8ThYPnxppn3tfpshyWfzeg__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy8xMDIwWDU1NS8qIiwiQ29uZGl0aW9uIjp7IkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzI3MjU5NDE1fX19XX0_',
      },
      width: null,
    },
    {
      created: '2024-09-23T17:27:09.482114+02:00',
      filename: 'file-sample_100kB_3 (3).doc',
      height: null,
      id: 5,
      mime_type: 'application/msword',
      origin:
        'https://files.idwell.at/olga.redesign.idwell.at/private/2024/09/file-sample_100kB_3_3.doc?Expires=1727259175&Signature=itNAn6HPuHX4WtBmNr653CuortfuXOhfq1t1~XzJMqyTe-dW2GSVPYU27rPsp4X34B3zl2wt5vEO7PzasrEJZEjEuctulS-cIyFllogYcfJnVKAQP0OZ4OLpNPOWJ~SfV7zTtwZTz9PhJrcpXpz5PdAdoHUGu8oVc7WJ0Cb7Dqsws~d7mXM7izHDGCmreOusoe93lIzM3dJzB5mvvVjv9JhGbCk7KRpJzVO3PYEcU-6zDOnYyVHzFbjSnLLuqzhFxQXr1gLhxFOyVlyFAbc4OpE0zoHrxfyK~FZ6Zj46OsNuictaf7Ild-VPZA7U4j6pjzt11P5Cp1diGnfYgj4QrQ__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ',
      permissions: {
        can_delete: true,
      },
      preview: null,
      size: 100352,
      thumbnail:
        'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/130X110/olga.redesign.idwell.at/private/2024/09/file-sample_100kB_3_3.doc?signed_redirect=1&Expires=1727259415&Signature=KyP0tpQp0oi7YHqhwdxW8vr63K4TkbdikrHzerUYvZY~40Pqnwlwz-Tck6qu3bBQDx~1vVwOly7ePmqebvSxPUZ9OR~6WUxIn6jgtiT0~CTg7VGfgi7GoNCdut6uVO3F9TF0q2zZMR4ClVmqmYnJ~ze3REvz2~KjQ6hyU6NqnRKr3nvmE3whfeUwbypyA2fugbsGvXAuzcDuqT-gsMbXqKDdUHnW8-siPuq3re2sgYe~4LXEshFDnQycrLXHWeZP1L4xp77FRbU8l5pN55D8HRk5mMVMI8rFjPO-DQVVN9UXsS80Y4g6QvaefoWwfw~5J2jjoeL1NDruRDx~x~7b6g__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy8xMzBYMTEwLyoiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MjcyNTk0MTV9fX1dfQ__',
      thumbnails: {
        512: 'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/512X512/olga.redesign.idwell.at/private/2024/09/file-sample_100kB_3_3.doc?signed_redirect=1&Expires=1727259415&Signature=d2fY7jbfViGYLvVX5IzNZych2HpKlXwnOd-nqLbXNwd8ilwVh4dneoIGywYlNWRNOU77ERcvANJ48RIWibgDzAvHot6IYYHhkGvKyxcBlGfcctC7tK0GMHiunsvfkMaVjtjPhDtoJuRPTDz-eUQ1Yo-jgIEzri2prySpLOoRXWtuiThkKS7KL-ek7ua-xQvELTakbQen7VTZ19XZxYXAodTBg3lk289vpKfYTiIib81zUKBTVvOezc6W0~m-lM9YlBXJeivujCzVlicGIn1OMIeaaL0jfnDrTPVJ6mpLDtRnN~gNgSGoEPjX37C7TvcMR--5-VPBj~scEMYZ83181Q__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy81MTJYNTEyLyoiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MjcyNTk0MTV9fX1dfQ__',
        1020: 'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/1020X555/olga.redesign.idwell.at/private/2024/09/file-sample_100kB_3_3.doc?signed_redirect=1&Expires=1727259415&Signature=GamL0R1yXnIt~U~lx-50dZAVPwv~ggEbgMUus0pwmXWemXsTe7y3geVd3EL2iCvEnkNKWiEEJyWEdcOYLXo6NNesBxSrjjAg5lhX5hULEVsWZ4SGHksYGyaF~q3Aoi3TODH2zriOrtW4X7pSrvYV~sZjMKM78Dgc-wtUdmDGQsAb7XwqRPpP0-1JlumvRUJ2xDNm77KxJ55xwdVjl5qgnIK0FyVYW2UDd4Iri9TYYzFYPawPZ301L7ra1prgVcWJPy4mTjyipSsacb6NdZgMF~9Bbt86QgliMWlmWU5Yd7S9N5lCVTymKmswW9Xm7FhI8ThYPnxppn3tfpshyWfzeg__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy8xMDIwWDU1NS8qIiwiQ29uZGl0aW9uIjp7IkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzI3MjU5NDE1fX19XX0_',
      },
      width: null,
    },
    {
      created: '2024-09-23T17:27:43.093484+02:00',
      filename: 'doc.pdf',
      height: null,
      id: 6,
      mime_type: 'application/pdf',
      origin:
        'https://files.idwell.at/olga.redesign.idwell.at/private/2024/09/doc.pdf?Expires=1727259175&Signature=SioBK2-ThuPnZ68JTqmRXp3ODQ6q5uF8a~kNnk8PX2oB6BbrK80LLgOQNhIpHytS416gsdxhCX3RDb543WC5khwGKNBWOTmLrXgTKahUv4SBMe5dJ4qz340wXxsQuwxs~0vzEAbU7dO2rkiD7CAtC9701Ru5gwgqB8f0DNNpMqIInVuSgeD9HU10U-gdTVZS1Av5t7gn0S87HPL8C~iMfm5Me5ZT~zwbdpqymotB98Dsj60JKAEprMHP138G14Jhj9QQmmLWoetimrDSz4O2ITgCsl4Hxht87BGFdQe0R2Hmc9GXy8S1jk4SKswtzsKndwbRwfAcVGmZrS8dFviG8w__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ',
      permissions: {
        can_delete: true,
      },
      preview: null,
      size: 574868,
      thumbnail:
        'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/130X110/olga.redesign.idwell.at/private/2024/09/doc.pdf?signed_redirect=1&Expires=1727259415&Signature=KyP0tpQp0oi7YHqhwdxW8vr63K4TkbdikrHzerUYvZY~40Pqnwlwz-Tck6qu3bBQDx~1vVwOly7ePmqebvSxPUZ9OR~6WUxIn6jgtiT0~CTg7VGfgi7GoNCdut6uVO3F9TF0q2zZMR4ClVmqmYnJ~ze3REvz2~KjQ6hyU6NqnRKr3nvmE3whfeUwbypyA2fugbsGvXAuzcDuqT-gsMbXqKDdUHnW8-siPuq3re2sgYe~4LXEshFDnQycrLXHWeZP1L4xp77FRbU8l5pN55D8HRk5mMVMI8rFjPO-DQVVN9UXsS80Y4g6QvaefoWwfw~5J2jjoeL1NDruRDx~x~7b6g__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy8xMzBYMTEwLyoiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MjcyNTk0MTV9fX1dfQ__',
      thumbnails: {
        512: 'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/512X512/olga.redesign.idwell.at/private/2024/09/doc.pdf?signed_redirect=1&Expires=1727259415&Signature=d2fY7jbfViGYLvVX5IzNZych2HpKlXwnOd-nqLbXNwd8ilwVh4dneoIGywYlNWRNOU77ERcvANJ48RIWibgDzAvHot6IYYHhkGvKyxcBlGfcctC7tK0GMHiunsvfkMaVjtjPhDtoJuRPTDz-eUQ1Yo-jgIEzri2prySpLOoRXWtuiThkKS7KL-ek7ua-xQvELTakbQen7VTZ19XZxYXAodTBg3lk289vpKfYTiIib81zUKBTVvOezc6W0~m-lM9YlBXJeivujCzVlicGIn1OMIeaaL0jfnDrTPVJ6mpLDtRnN~gNgSGoEPjX37C7TvcMR--5-VPBj~scEMYZ83181Q__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy81MTJYNTEyLyoiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MjcyNTk0MTV9fX1dfQ__',
        1020: 'https://files.idwell.at/olga.redesign.idwell.at/v2/thumbnails/1020X555/olga.redesign.idwell.at/private/2024/09/doc.pdf?signed_redirect=1&Expires=1727259415&Signature=GamL0R1yXnIt~U~lx-50dZAVPwv~ggEbgMUus0pwmXWemXsTe7y3geVd3EL2iCvEnkNKWiEEJyWEdcOYLXo6NNesBxSrjjAg5lhX5hULEVsWZ4SGHksYGyaF~q3Aoi3TODH2zriOrtW4X7pSrvYV~sZjMKM78Dgc-wtUdmDGQsAb7XwqRPpP0-1JlumvRUJ2xDNm77KxJ55xwdVjl5qgnIK0FyVYW2UDd4Iri9TYYzFYPawPZ301L7ra1prgVcWJPy4mTjyipSsacb6NdZgMF~9Bbt86QgliMWlmWU5Yd7S9N5lCVTymKmswW9Xm7FhI8ThYPnxppn3tfpshyWfzeg__&Key-Pair-Id=APKAJR3NXAIAR76HPMQQ&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9maWxlcy5pZHdlbGwuYXQvb2xnYS5yZWRlc2lnbi5pZHdlbGwuYXQvdjIvdGh1bWJuYWlscy8xMDIwWDU1NS8qIiwiQ29uZGl0aW9uIjp7IkRhdGVMZXNzVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzI3MjU5NDE1fX19XX0_',
      },
      width: null,
    },
  ],
  is_liked: false,
  is_pinned: false,
  is_unread: false,
  last_messages: null,
  new_audience: ['ToAllColleagues', 'ToAllBuildings'],
  owner: {
    avatar: null,
    avatar_color: '#8421a5',
    flats_count: 0,
    fullname: 'Admin Admin',
    group: 'admin',
    id: 12831,
    is_landlord: false,
    name: 'Admin',
    second_name: 'Admin',
    status: 1,
  },
  permissions: {
    can_add_comment: true,
    can_block_post: true,
    can_block_user: true,
    can_edit: true,
    can_like_post: true,
    can_pin_post: true,
    can_unblock_post: false,
    can_unblock_user: false,
    can_unlike_post: false,
    can_unpin_post: false,
    can_view_viewers: true,
  },
  post_type: {
    id: 5,
    title: 'post',
  },
  post_type_category: 'post',
  request_dump: null,
  requests: null,
  spam: false,
  status: 'online',
  style: null,
  text: '<p>My files gallery</p>',
  title: 'gallery',
  type: 1,
  updated: '2024-09-04T16:27:19.376287+02:00',
  uuid: 'cab74298-6ac9-11ef-bae7-0242ac120008',
}

export const POST_ITEM_AUDIENCE = {
  body: null,
  building_group_objs: [],
  building_groups: [],
  buildings: [
    {
      id: 7737,
      title: "10 Askhi St, T'bilisi, Georgia",
    },
  ],
  chat: null,
  comment_count: 0,
  comments_forbidden: false,
  counters: { likes: 5 },
  created: '2024-09-10T15:32:33.551100+02:00',
  created_by: 12831,
  date_from: null,
  date_to: null,
  files: [],
  is_liked: false,
  is_pinned: false,
  is_unread: false,
  last_messages: null,
  like_count: 0,
  new_audience: [
    'ToDigitalBoard',
    'ToAllFriends',
    'ToAllColleagues',
    'ToSignedUpDwellers',
    'ToSignedUpLandlords',
  ],
  owner: {
    avatar: null,
    flats_count: 0,
    fullname: 'Monica Becker',
    group: 'admin',
    id: 12831,
    is_landlord: false,
    name: 'Monica',
    second_name: 'Becker',
    status: 1,
  },
  permissions: {
    can_add_comment: true,
    can_block_post: true,
    can_block_user: true,
    can_edit: true,
    can_like_post: true,
    can_pin_post: true,
    can_unblock_post: false,
    can_unblock_user: false,
    can_unlike_post: false,
    can_unpin_post: false,
    can_view_viewers: true,
  },
  post_type: {
    id: 5,
    title: 'post',
  },
  post_type_category: 'post',
  request_dump: null,
  requests: null,
  spam: false,
  status: 'offline',
  style: null,
  text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod<br/>tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim<br/>veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea<br/>commodo consequat. Duis aute irure dolor in reprehenderit in voluptate<br/>velit esse cillum doloreLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod<br/>tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim<br/>veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea<br/>commodo consequat. Duis aute irure dolor in reprehenderit in voluptate<br/>velit esse cillum dolore',
  title: 'Lorem ipsum dolor',
  type: 1,
  updated: '2024-09-10T15:32:33.551122+02:00',
  uuid: '22b0a724-6f79-11ef-aacb-0242ac120003',
  views_counter: 0,
}
